/* eslint-disable no-template-curly-in-string, no-useless-escape */
export const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
  string: {
    max: "${label} must be up to ${max} characters",
    min: "${label} must be at least ${min} characters",
    range: "${label} must be between ${min} and ${max} characters",
  },
};

export const passwordValidator = (_, value) => {
  if (!value) {
    return Promise.reject(new Error("Password is required"));
  }

  const minLength = 10;
  const lowercasePattern = /[a-z]/;
  const uppercasePattern = /[A-Z]/;
  const digitPattern = /[0-9]/;
  const specialCharPattern = /[!@#$%^&*()_+|~\-=`{}\[\]:";'<>?,./]/;
  const noSpacesPattern = /^\S*$/;

  if (value.length < minLength) {
    return Promise.reject(
      new Error(`Password must be at least ${minLength} characters`)
    );
  }

  if (!lowercasePattern.test(value)) {
    return Promise.reject(
      new Error("Password must contain at least one lowercase letter")
    );
  }

  if (!uppercasePattern.test(value)) {
    return Promise.reject(
      new Error("Password must contain at least one uppercase letter")
    );
  }

  if (!digitPattern.test(value)) {
    return Promise.reject(
      new Error("Password must contain at least one digit")
    );
  }

  if (!specialCharPattern.test(value)) {
    return Promise.reject(
      new Error("Password must contain at least one special character")
    );
  }

  if (!noSpacesPattern.test(value)) {
    return Promise.reject(new Error("Password cannot contain spaces"));
  }

  return Promise.resolve();
};

export const cellPhoneValidator =
  (label = "Cell Phone") =>
  (_, value) => {
    if (!value) {
      return Promise.reject(new Error(`${label} is required`));
    }
    const phoneNumberRegex = /^\+?[0-9]{1,}$/;

    if (!phoneNumberRegex.test(value)) {
      return Promise.reject(
        `${label} must consist only of digits and an optional "+" symbol.`
      );
    }

    const startPatternRegex = /^(?![=\-@])/;

    if (!startPatternRegex.test(value[0])) {
      return Promise.reject(`${label} cannot start with '=', '-', or '@'.`);
    }

    const digitCount = value.startsWith("+") ? value.length - 1 : value.length;
    if (digitCount < 3) {
      return Promise.reject(`${label} must be at least 3 digits.`);
    } else if (digitCount > 20) {
      return Promise.reject(`${label} must not exceed 20 digits.`);
    }

    return Promise.resolve();
  };

export const startPatternRule = {
  pattern: /^(?![=+\-@])/,
  message: "${label} cannot start with =, +, -, or @",
};
